export const defaultMentorRole = '22';
export const mentorRoles = ['10', '11', '20', '21', '22'];
export const supervisorRoles = ['30'];
export const adminRoles = ['30', '40', '41'];

export const ROLES = {
  CLINICAL_MENTOR_HEB: '10',
  EMOTIONAL_MENTOR_HEB: '11',
  CLINICAL_MENTOR_EN: '20',
  EMOTIONAL_MENTOR_EN: '21',
  DEFAULT_MENTOR: '22',
  SUPERVISOR: '30',
  TECH_ADMIN: '40',
  MANAGEMENT_ADMIN: '41',
};
